export const replaceNToBr = (text: string | null | undefined, isManualAdding?: boolean): string => {
  if (!text) {
    return '';
  }

  // TODO: Check to remove isManualAdding, seems don't need this condition
  // Manual adding is used for the case when the text is already escaped
  return isManualAdding ? text.replace(/\\n/g, '<br />') : text.replace(/\n/g, '<br />');
};
